import { createContext, useContext, useEffect, type ReactNode } from "react";

// Die Kopfzeile gehört zur Seite, nicht zum Rahmen: sie trägt den Pfad zur
// aktuellen Seite. Die Seite meldet ihre Brotkrumen an, der Rahmen zeigt sie.

export type Crumb = {
  label: string;
  /** Ziel — ohne to ist die Krume die aktuelle Seite */
  to?: string;
};

type CrumbState = { crumbs: Crumb[]; setCrumbs: (c: Crumb[]) => void };

const CrumbContext = createContext<CrumbState>({ crumbs: [], setCrumbs: () => {} });

export function CrumbProvider({ value, children }: { value: CrumbState; children: ReactNode }) {
  return <CrumbContext.Provider value={value}>{children}</CrumbContext.Provider>;
}

export function useCrumbs(): Crumb[] {
  return useContext(CrumbContext).crumbs;
}

/**
 * Brotkrumen der aktuellen Seite anmelden. Der Vergleich läuft über den
 * serialisierten Wert — Aufrufer dürfen das Array bei jedem Render neu bauen,
 * ohne eine Render-Schleife auszulösen.
 */
export function usePageCrumbs(crumbs: Crumb[]): void {
  const { setCrumbs } = useContext(CrumbContext);
  const key = JSON.stringify(crumbs);
  useEffect(() => {
    setCrumbs(JSON.parse(key) as Crumb[]);
    // Beim Verlassen leeren: die nächste Seite meldet im selben Commit ihre
    // eigenen an, es blitzt also keine leere Kopfzeile auf.
    return () => setCrumbs([]);
  }, [key, setCrumbs]);
}
